module.exports = __webpack_public_path__ + "UX11.png?39e51ecf6fc404795564a4527147df86";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX11.png
// module id = 60
// module chunks = 0